<dbx-entry-skeleton>
  <div class="form-container" data-cy="reset-password-page">
    <h2 class="title">{{ 'resetPassword.title' | translate }}</h2>
    <p>{{ 'resetPassword.description' | translate }}</p>
    <ul>
      <li>{{ 'resetPassword.rules.1' | translate }}</li>
      <li>{{ 'resetPassword.rules.2' | translate }}</li>
    </ul>
    <form class="form" [formGroup]="form" (ngSubmit)="submit()">
      <div class="form-field">
        <mat-form-field class="field" floatLabel="always">
          <mat-label>{{ 'resetPassword.newPassword' | translate }}</mat-label>
          <input
            id="password"
            [type]="showPassword() ? 'text' : 'password'"
            name="password"
            data-cy="password-input"
            formControlName="password"
            [placeholder]="'resetPassword.newPassword' | translate"
            required
            matInput
            [errorStateMatcher]="errorStateMatcher"
            dbxFocus
          />
          <mat-icon matSuffix data-cy="password-visibility-toggle" (click)="togglePassword()">
            {{ showPassword() ? 'visibility' : 'visibility_off' }}
          </mat-icon>
          @if (submitted() && password?.invalid) {
            <mat-error class="">
              @if (password?.hasError('required')) {
                {{ 'resetPassword.errors.newPasswordRequired' | translate }}
              } @else if (password?.hasError('minlength')) {
                {{ 'resetPassword.errors.passwordMinLength' | translate }}
              } @else if (password?.hasError('invalidPassword')) {
                {{ 'resetPassword.errors.invalidPassword' | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field class="field" floatLabel="always">
          <mat-label>{{ 'resetPassword.confirmPassword' | translate }}</mat-label>
          <input
            id="confirm"
            [type]="showConfirm() ? 'text' : 'password'"
            name="confirm"
            data-cy="confirm-password-input"
            formControlName="confirm"
            [placeholder]="'resetPassword.confirmPassword' | translate"
            required
            matInput
            [errorStateMatcher]="errorStateMatcher"
          />
          <mat-icon matSuffix data-cy="confirm-password-visibility-toggle" (click)="toggleConfirm()">
            {{ showConfirm() ? 'visibility' : 'visibility_off' }}
          </mat-icon>
          @if (submitted() && confirm?.invalid) {
            <mat-error>
              @if (confirm?.hasError('required')) {
                {{ 'resetPassword.errors.confirmPasswordRequired' | translate }}
              } @else if (confirm?.hasError('minlength')) {
                {{ 'resetPassword.errors.passwordMinLength' | translate }}
              } @else if (confirm?.hasError('passwordMismatch')) {
                {{ 'resetPassword.errors.passwordDoNotMatch' | translate }}
              }
            </mat-error>
          }
        </mat-form-field>
      </div>

      <button mat-flat-button class="full-width" [disabled]="loading()" type="submit">
        <span class="loading-button-container">
          <span [style.visibility]="loading() ? 'hidden' : 'visible'">
            {{ 'resetPassword.submit' | translate }}
          </span>
          @if (loading()) {
            <mat-spinner class="white" diameter="20" />
          }
        </span>
      </button>
    </form>
  </div>
</dbx-entry-skeleton>
